import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {NgClass} from '@angular/common';
import {Subject, takeUntil} from 'rxjs';
import {ModalConfig, ModalService} from '../../../core/services/modal.service';
import Modal from 'bootstrap/js/dist/modal';

@Component({
    selector: 'app-error-modal',
    standalone: true,
    imports: [NgClass],
    templateUrl: './error-modal.component.html',
    styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent implements OnInit, OnDestroy {
    private _modalService = inject(ModalService);
    private _unsubscribeAll = new Subject<void>();
    private _modalInstance: any = null;

    modalConfig: ModalConfig = {
        show: false,
        title: '',
        message: '',
        type: 'error'
    };

    ngOnInit(): void {
        this._modalService.modalConfig$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config: ModalConfig) => {
                this.modalConfig = config;
                
                if (config.show) {
                    this.showModal();
                } else {
                    this.hideModal();
                }
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        
        if (this._modalInstance) {
            this._modalInstance.dispose();
        }
    }

    private showModal(): void {
        const modalElement = document.getElementById('errorModal');
        if (modalElement) {
            if (!this._modalInstance) {
                this._modalInstance = new Modal(modalElement);
            }
            this._modalInstance.show();
        }
    }

    private hideModal(): void {
        if (this._modalInstance) {
            this._modalInstance.hide();
        }
    }

    onClose(): void {
        const callback = this.modalConfig.onClose;
        this._modalService.hide();
        if (callback) {
            callback();
        }
    }

    get alertClass(): string {
        switch (this.modalConfig.type) {
            case 'error':
                return 'alert-danger';
            case 'warning':
                return 'alert-warning';
            case 'success':
                return 'alert-success';
            default:
                return 'alert-danger';
        }
    }

    get iconClass(): string {
        switch (this.modalConfig.type) {
            case 'error':
                return 'bi-exclamation-circle-fill';
            case 'warning':
                return 'bi-exclamation-triangle-fill';
            case 'success':
                return 'bi-check-circle-fill';
            default:
                return 'bi-exclamation-circle-fill';
        }
    }
}

